import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Header, Button, Modal } from 'semantic-ui-react';

class AutoReload extends Component {
  constructor(props) {
    super(props);
    this.previousHash = null;
    this.state = {
      codeHasChanged: false,
    };
    this.fetchSource = this.fetchSource.bind(this);
  }

  componentDidMount() {
    const { tryDelay } = this.props;
    this.fetchSource();
    this.interval = setInterval(this.fetchSource, tryDelay);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchSource() {
    return fetch(this.props.url)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('offline');
        }
        return response.text();
      })
      .then((html) => {
        const hash = this.hash(html);
        if (!this.previousHash) {
          this.previousHash = hash;
          return;
        }
        if (this.previousHash !== hash) {
          this.previousHash = hash;
          this.setState({ codeHasChanged: true });
        }
      })
      .catch(() => {
        /* do nothing */
      });
  }

  /**
   * Java-like hashCode function for strings
   *
   * taken from http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery/7616484#7616484
   */
  hash(str) {
    const len = str.length;
    let hash = 0;
    if (len === 0) return hash;
    let i;
    for (i = 0; i < len; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  reloadApp(e) {
    window.location.reload();
    e.preventDefault();
  }

  render() {
    return (
      <Modal
        open={this.state.codeHasChanged}
        closeOnDimmerClick
        closeOnEscape
        onClose={this.reloadApp}
      >
        <Header
          icon='download'
          content={`A new version of the ${process.env.REACT_APP_ORG_NAME} app is available.`}
        />
        <Modal.Content>
          Click OK to update or refresh your browser window.
        </Modal.Content>
        <Modal.Actions>
          <Button
            icon='checkmark'
            primary
            labelPosition='right'
            onClick={this.reloadApp}
            content='OK'
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

AutoReload.propTypes = {
  url: PropTypes.string.isRequired,
  tryDelay: PropTypes.number.isRequired,
};

AutoReload.defaultProps = {
  url: '/',
  tryDelay: 60 * 60 * 1000, // 1 hour
};

export default AutoReload;
